<template>
  <div class="box-header">
    <div class="head-right">
      <div class="unitTitle">中物鉴智（成都）科技成果评价有限公司</div>
      <div class="head-right-two desktop-nav">
        <router-link
          v-for="(item, index) in nav"
          :key="index"
          :to="item.path"
          class="name"
          :class="{ active: isCurrentPath(item.path) }"
        >
          <div v-if="isCurrentPath(item.path)" class="dir"></div>
          <div> {{ item.name }} </div>
        </router-link>
        <div @click="toRegister">
          <a href="#" class="apply-btn">评价申请入口</a>
        </div>
        <div class="phone-box">
          <i style="font-size: 22px;" class="iconfont icon-dianhua"></i>
          400-136-5770
        </div>
      </div>
      <div class="mobile-menu-btn" @click="toggleMobileMenu">
        <span class="icon-menu"></span>
      </div>
      <div class="mobile-nav" v-show="showMobileMenu">
        <div 
          v-for="(item, index) in nav" 
          :key="index" 
          class="mobile-nav-item"
        >
          <router-link
            :to="item.path"
            class="mobile-nav-link"
            :class="{ active: isCurrentPath(item.path) }"
            @click.native="showMobileMenu = false"
          >
            {{ item.name }}
          </router-link>
        </div>
        <div @click="toRegister" style="margin-top: 10px;" class="mobile-nav-item">
          <a href="#" class="apply-btn">评价申请入口</a>
        </div>
        <div style="margin-top: 10px;" class="mobile-nav-item mobile-phone-box">
          <i style="font-size: 22px;color: #03ABFE;margin-right: 5px;" class="iconfont icon-dianhua"></i>
          <span style="font-size: 16px;color: #03ABFE;"> 400-136-5770</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectIndex: '/',
      showMobileMenu: false, 
      nav: [
        {
          name: '评价首页',
          path: '/',
        },
        {
          name: '评价案例',
          path: '/index/caseCenter',
        },
        {
          name: '报告查询',
          path: '/index/newsCenter',
        },
        {
          name: '关于我们',
          path: '/index/aboutUs',
        },
        {
          name: '通知公告',
          path: '/index/notification',
        },
      ]
    };
  },
  methods: {
    isCurrentPath(targetPath) {
      const currentPath = this.$route.path;
      if (targetPath === '/') {
        return currentPath === '/' || currentPath === '/index/home';
      }
      if (['/index/productCenterTy', '/index/productCenterJs', '/index/productCenterTyDkm'].includes(currentPath)) {
        return targetPath === '/index/productCenter';
      }
      if (currentPath.startsWith('/index/notification')) {
        return targetPath === '/index/notification';
      }
      return currentPath === targetPath;
    },
    btnNavFn(path) {
      if (this.$route.path === path) return;
      this.$router.push(path);
      this.showMobileMenu = false; 
    },
    toRegister() {
      window.location.href =  this.$toPathUrl + "login/user";
      this.showMobileMenu = false; 
    },
    toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu;
    },
    handleResize() {
      const width = window.innerWidth;
      if (width > 1350) {
        this.showMobileMenu = false;
      }
    }
  },
  watch: {
    "$route.path"(path) {
      if (['/index/productCenterTy', '/index/productCenterJs', '/index/productCenterTyDkm'].includes(path)) {
        this.selectIndex = '/index/productCenter';
      } else if (path.startsWith('/index/notification')) {
        this.selectIndex = '/index/notification';
      } else if (path === '/index/home') {
        this.selectIndex = '/';
      } else {
        this.selectIndex = path;
      }
    }
  },
  created() {
    const path = this.$route.path;
    if (['/index/productCenterTy', '/index/productCenterJs', '/index/productCenterTyDkm'].includes(path)) {
      this.selectIndex = '/index/productCenter';
    } else if (path.startsWith('/index/notification')) {
      this.selectIndex = '/index/notification';
    } else if (path === '/index/home') {
      this.selectIndex = '/';
    } else {
      this.selectIndex = path;
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>

<style lang="less" scoped>
.icon-menu, .icon-down, .icon-up {
  display: inline-block;
  box-sizing: border-box;
  font-size: 0;
  border: none;
}
.icon-menu {
  width: 24px;
  height: 24px;
  position: relative;
  &::before, &::after {
    content: '';
    position: absolute;
    left: 0;
    width: 100%;
    height: 3px;
    background: #333;
    border-radius: 2px;
  }
  &::before {
    top: 6px;
  }
  &::after {
    bottom: 6px;
  }
  span {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    height: 3px;
    background: #333;
    border-radius: 2px;
  }
}

.box-header {
  height: 70px;
  background: #fff;
  align-items: center;
  display: flex;
  justify-content: flex-start;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.1);
  z-index: 999;
  position: relative; 

  .head-right {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;

    .head-right-two {
      display: flex;
      align-items: center;
    }

    .name {
      color: #000;
      margin-right: 50px;
      font-size: 16px;
      cursor: pointer;
      display: flex;
      align-items: center;
      text-indent: 20px;
      text-decoration: none;
      position: relative;
      &.active {
        color: #2B58F9;
      }
    }

    .dir {
      height: 16px;
      background: #2B58F9;
      position: absolute;
      left: 0px;
      width: 4px;
    }
  }

  .phone-box {
    font-size: 20px;
    font-weight: bold;
    background: -webkit-linear-gradient(#eee, #03ABFE);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-right: 60px;
    display: flex;
    align-items: center;
  }

  .unitTitle {
    font-size: 25px;
    color: #000;
    margin-left: 30px;
  }

  .apply-btn {
    display: inline-block;
    background: #ff7f00;
    color: white;
    font-weight: 600;
    border-radius: 14px;
    padding: 5px 10px;
    display: flex;
    align-items: center;
    margin-right: 10px;
    justify-content: center;
    text-decoration: none; 
  }
  .mobile-menu-btn {
    display: none;
    cursor: pointer;
    margin-right: 20px;
    color: #333;
    align-items: center;
    justify-content: center;
  }
  .mobile-nav {
    position: absolute;
    top: 70px;
    right: 0;
    width: 200px;
    background: #fff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 9999;
    padding: 10px 0;

    .mobile-nav-item {
      padding: 0 15px;

      .mobile-nav-link {
        text-align: center;
        padding: 12px 0;
        color: #333;
        cursor: pointer;
        font-size: 16px;
        border-bottom: 1px solid #f5f5f5;
        &:hover {
          color: #2B58F9;
        }
        &.active {
          color: #2B58F9;
        }
      }

      .mobile-phone-box {
        padding: 12px 0;
        font-size: 18px;
        border-bottom: none;
        display: flex;
        align-items: center;
        background: -webkit-linear-gradient(#eee, #03ABFE);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-weight: bold;
      }
    }
  }
}

@media (max-width: 1500px) {
  .desktop-nav {
    display: none !important; 
  }

  .mobile-menu-btn {
    display: flex !important; 
  }

  .box-header .unitTitle {
    font-size: 20px; 
    margin-left: 15px;
  }
}
@media (max-width: 768px) {
  .box-header .unitTitle {
    font-size: 16px;
  }

  .mobile-nav {
    width: 100%; 
  }
}
</style>